import {
  RoomType,
} from "../../types/floorplannerTypes";
import { observer } from "mobx-react-lite";
import { floorplannerStore } from "../../store/floorplannerStore";
import { RoomLabel } from "./RoomLabel";
import { editorStore } from "../../store/editorStore";

const RoomLabelStructure = observer(() => {
  const shouldShowMeasurements = editorStore.shouldShowMeasurements();

  return (
    <>
      {/* <RoomLabels rooms={rooms} /> */}
      {
        shouldShowMeasurements &&
        Array.from(floorplannerStore.roomsMap.values())
          .filter((room) => {
            // Filter out "ghost" rooms that might remain in the map but are no longer referenced by their walls
            // This prevents duplicate labels appearing after drag operations
            if (!room.objectIds || room.objectIds.length === 0) return false;

            // A room is valid only if at least one of its forming objects actually points back to it
            return room.objectIds.some(id => {
              const obj = floorplannerStore.findObjectId(id);
              return obj && 'roomIds' in obj && (obj as any).roomIds?.includes(room.id);
            });
          })
          .map((room: RoomType) => (
            <RoomLabel key={room.id} room={room} />
          ))
      }
    </>

  );
});

export default RoomLabelStructure;
